import { FunctionComponent, useState } from 'react';
import { Box, Tab, Typography, useTheme } from '@mui/material';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Theme } from '@mui/material/styles';
import { TicketTemplateTab } from './TicketTemplateTab';

interface ExtendedTheme extends Theme {
    page: {
        verticalSpacing: number;
        backgroundColor: string;
        template: {
            base: {
                paddingX: number;
                paddingY: number;
            };
        };
    };
}

type TabValue = 'eticket' | 'pickupticket' | 'barcodeticket';

const INFO_TEXT = 'Unterstütztes Format: PDF. Empfohlene Größe: A4.';
const INTEGRATION_EXTRA_INFO =
    'Diese Vorlage wird nur für Integration-Buchungen verwendet.';

export const TicketTemplatesPageContent: FunctionComponent = () => {
    const theme = useTheme() as ExtendedTheme;
    const [tabValue, setTabValue] = useState<TabValue>('eticket');

    const handleTabChange = (_: unknown, newValue: TabValue) => {
        setTabValue(newValue);
    };

    return (
        <>
            <Typography sx={{ mb: 4 }} variant='h4'>
                Ticketvorlagen
            </Typography>

            <TabContext value={tabValue}>
                <Box
                    sx={{
                        borderBottom: '1px solid',
                        borderColor: 'divider',
                        mb: theme.page?.verticalSpacing ?? 3,
                    }}
                >
                    <TabList onChange={handleTabChange}>
                        <Tab label='Smartphoneticket' value='eticket' />
                        <Tab label='Pick-Up-Voucher' value='pickupticket' />
                        <Tab
                            label='e-Ticket (Barcodeticket)'
                            value='barcodeticket'
                        />
                    </TabList>
                </Box>

                <TabPanel value='eticket' sx={{ p: 0 }}>
                    <TicketTemplateTab
                        name='eticket'
                        infoText={INFO_TEXT}
                        extraInfoText={INTEGRATION_EXTRA_INFO}
                    />
                </TabPanel>

                <TabPanel value='pickupticket' sx={{ p: 0 }}>
                    <TicketTemplateTab
                        name='pickupticket'
                        infoText={INFO_TEXT}
                        extraInfoText={INTEGRATION_EXTRA_INFO}
                    />
                </TabPanel>

                <TabPanel value='barcodeticket' sx={{ p: 0 }}>
                    <TicketTemplateTab
                        name='barcodeticket'
                        infoText={INFO_TEXT}
                        extraInfoText={INTEGRATION_EXTRA_INFO}
                    />
                </TabPanel>
            </TabContext>
        </>
    );
};
